<template>
    <div class="animated fadeIn"> 
        <b-card>
            <!-- header strat -->
            <div slot="header" class="mb-2">
                <b-row>
                    <b-col sm="3">
                        <img src="../../public/img/rb_logo.png" alt="RocketBess" style="width: 100%;
                        height: 70px;">
                    </b-col>
                    <b-col sm="6">
                        <div class="text-center mt-4">
                            <strong><i class="cui-graph icons font-2xl mt-4"></i> &nbsp; Shipment Tracking </strong>
                        </div>
                        <div class="card-header-actions">                      
                        </div>
                    </b-col>
                </b-row>
            </div>  
            <!-- header end -->

            <div id="listloader" v-if="isloader">
                <div class="listloader"></div>
            </div>
            <!-- Track Your Shipment start-->
            <div class="mt-5">

                <!-- <b-card class="card1">
                    <b-row>
                        <b-col xs="12" sm="12" md="12" lg="3" xl="3" class="tracking">
                            <i class="cui-graph icons"></i>
                            <pre class="tractship">Track Your Shipment
                            </pre>
                        </b-col>
                        <b-col xs="12" sm="12" md="11" lg="8" xl="8">
                            <div>
                                <b-row>
                                    <b-col xs="12" sm="12" md="5" lg="5" xl="4" class="mt-5 pr-0">
                                        <pre class="parentawb">Parent AWB / Invoice No :</pre>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="4" lg="4" xl="4" class="mt-4 pl-0">
                                        <div class="iyJSqT">
                                            <input type="text" class="form-control-plaintext" placeholder="Enter AWB No." required v-model="parentawb" @input="checklength(parentawb)">
                                        </div>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="3" lg="3" xl="4" class="mt-4 paddingout">
                                        
                                            paddingout
                                            <b-form-input  class="form-control"  type="text" name="text" id="text" placeholder="Captcha" v-model="text" style=" padding: 6px 12px;" 
                                        @change="checkcaptcha"/>
                                        <span v-if="capAlert" style="font-family: 'CoreUI-Icons-Linear-Free'; font-size:15px;color:red; margin-left: 17px;">Invalid Captcha!
                                        </span>
                                        <b-input-group>
                                            <captcha-code
                                                :captcha.sync="code"
                                                @on-change="handleChange"
                                                ref="captcha"
                                                style="width: 20px; height: 50px; display:none">
                                            </captcha-code>
                                            <div class="captcha-area">
                                                <span class="captcha">{{code}}</span>
                                            </div>
                                            <i class="fa fa-refresh mt-2" aria-hidden="true" @click="handleClick" style="font-size: 25px;
                                            color: rgb(237 111 17);"></i>
                                        </b-input-group>
                                        <div>
                                            <vue-recaptcha
                                            ref="recaptcha"
                                            @verify="onCaptchaVerified"
                                            @expired="onCaptchaExpired"
                                            :sitekey="yourSiteKey"
                                            class="custom-recaptcha"
                                          ></vue-recaptcha>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col xs="12" sm="12" md="1" lg="1" xl="1" class="mt-4 pl-0 textcenter">
                            <button class="btny" @click="search()">
                            <i class="fa fa-search" aria-hidden="true" style="font-size: 20px;"></i>
                            </button>
                        </b-col>
                    </b-row>
                </b-card> -->
                <b-card class="card1">
                    <b-row>
                        <b-col xs="12" sm="12" md="12" lg="2" xl="2" class="tracking pr-0">
                            <i class="cui-graph icons"></i><br>
                            <span class="tractship">Track Your Shipment
                            </span>
                        </b-col>
                        <b-col xs="12" sm="12" md="5" lg="2" xl="3" class="mt-4">
                            <span class="parentawb">Parent AWB / Invoice No :</span>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" lg="3" xl="3" class="mt-2 pl-0">
                            <div class="iyJSqT">
                                <input type="text" class="form-control-plaintext" placeholder="Enter AWB No." required v-model="parentawb" @input="checklength(parentawb)">
                            </div>
                        </b-col>
                        <b-col xs="12" sm="12" md="6" lg="4" xl="3" class="mt-2">
                            <!-- <div>
                                <vue-recaptcha
                                ref="recaptcha"
                                @verify="onCaptchaVerified"
                                @expired="onCaptchaExpired"
                                :sitekey="yourSiteKey"
                                class="custom-recaptcha"
                              ></vue-recaptcha>
                            </div> -->

                             <b-input-group>

                              <b-form-input
                                v-model="captcha"
                                placeholder="Enter Captcha"
                                autocomplete="off" style="height: 45px;">
                              </b-form-input>

                              <b-input-group-append>

                                <div
                                  class="captcha-box"
                                  v-html="captchaImage">
                                </div>

                                <b-button
                                  variant="outline-primary"
                                  @click="loadCaptcha">
                                  <i class="fa fa-refresh"></i>
                                </b-button>

                              </b-input-group-append>

                            </b-input-group>

                        </b-col>
                        <b-col xs="12" sm="12" md="1" lg="1" xl="1" class="mt-3 textcenter">
                            <button class="btny" @click="search()">
                            <i class="fa fa-search" aria-hidden="true" style="font-size: 20px;"></i>
                            </button>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
            <!-- Track Your Shipment end-->

            <!-- View Your Shipments start -->
             <!-- {{ items }} -->
            <div class="contentshow" :class="{ 'active': searchviewshipment }">
                <b-card class="shipmentview">
                    <h4><pre><b class="shipfont">Your Domestic Shipments</b></pre></h4>
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <div class="tableheadershow text-center">AWB No.</div>
                                </th>
                                <th>
                                    <div class="tableheadershow text-center">Status</div>
                                </th>
                                <th>
                                    <div class="tableheadershow text-center">Status Update Date-Time</div>
                                </th>
                                <th>
                                    <div class="tableheadershow text-center">Origin</div>
                                </th>
                                <th>
                                    <div class="tableheadershow text-center">Destination</div>
                                </th>
                                <th>
                                    <div class="tableheadershow text-center">EDD</div>
                                </th>
                                <th>
                                    <div class="tableheadershow text-center">View Shipment Journey</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="loader">
                                <td colspan="12" class="text-center">
                                    <b-spinner label="Loading..."></b-spinner>
                                </td>
                            </tr>

                            <tr v-for="item in items" :key="item.parentawb">
                                <td data-label="AWB No. :">
                                    
                                    <div class="text-center">{{item.parentawb}}</div>
                                </td>
                                <td data-label="Status :">
                                    <div class="text-center">{{item.shipmentstatus}}</div>
                                </td>
                                <td data-label="Origin :">
                                    <div class="text-center">
                                        {{ item.lastmodifieddate?
                                        new Date(item.lastmodifieddate.replace(' ', 'T'))
                                            .toLocaleString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: true
                                            }) :""
                                        }}
                                    </div>
                                </td>
                                <td data-label="Origin :">
                                    <div class="text-center">{{item.sourceaddress}}</div>
                                </td>
                                <td data-label="Destination :">
                                    <div class="text-center">{{item.destinationaddress}}</div>
                                </td>
                                <td data-label="Destination :">
                                    <div class="text-center">{{item.calulatededd}}</div>
                                </td>
                                <td data-label="View Shipment Journey :">
                                    <div class="text-center" @click="viewtrackingDeatils(item.parentawb)" style="cursor: pointer;">
                                        <i class="fa fa-eye" aria-hidden="true"></i> &nbsp; View
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="itemsunscces">
                                <td colspan="12" class="text-center"><b>Invalid Parent AWB / Invoice No</b></td>
                            </tr>
                            <!-- Add more rows as needed -->
                        </tbody>
                    </table>
                    
                </b-card>
            </div>
            <!-- View Your Shipments end -->


            <!-- View tracking Details start-->
            <div v-if="showafterview">
                <div class="text-center">
                    <h3><pre><b class="broder">Tracking Details</b></pre></h3>
                </div>

                <div>
                    <table class="styled-table">
                        <thead>
                            <tr>
                                 <th>AWB Number</th>
                                <th>Date</th>
                                <!--<th>Shipment Status</th>-->
                                <th>Tracking Description</th>
                            </tr>
                        </thead>
                        <tbody v-if="loadert">
                            <tr>
                                <td colspan="12" class="text-center">
                                    <b-spinner label="Loading..."></b-spinner>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-if="trackingitemlength>0">
                            <tr v-for="item in trackingitems" :key="item.parentawb"
  v-if="item.shipmentstatus !== 'NotAttempted'">
                                 <td data-label="AWB Number :">{{item.parentawb}}</td>
                                <td data-label="Date :">
                                    <!-- {{item.createddate}} -->
                                    {{
                                        new Date(item.createddate).toLocaleString('en-GB', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                        hour12: true
                                        })
                                    }}

                                    
                                </td>
                               <!--<td data-label="shipmentstatus :">{{item.shipmentstatus}}</td>-->

                                <td data-label="Tracking Description :">{{item.tracking_description}} 
					<div v-if="item.shipmentstatus === 'Delivered' || item.shipmentstatus === 'partialDLV'">
                                         <a href="javascript:void(0)" @click="downloadPOD()">
                                            Download POD
                                        </a>
                                    </div>
                                </td>                          
                            
                            </tr>
                            <!-- Add more rows as needed -->
                        </tbody>
                        <tbody v-if="trackingitemsunscces">
                            <tr>
                                <td colspan="12" class="text-center">{{trackingitemsunscces}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                
            </div>
            <!-- View tracking Details end-->
        </b-card>
    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import VueRecaptcha from 'vue-recaptcha';
import auth from '@/utils/auth'
import Vue from 'vue'
import CaptchaCode from "vue-captcha-code";
export default {

    data() {
        return {
            isloader : false,
            parentawb :'',
            searchviewshipment : false,
            items :[],
            itemlength :0,
            itemsunscces :'',
            loader : false,

            // tracking 
            loadert : false,
            trackingitems:[],
            trackingitemlength :0,
            trackingitemsunscces :'',
            showafterview : false,

            //captcha
            text :'',
            code :'',
            capAlert : false,
            // yourSiteKey: '6Lf-fFkpAAAAAOk0jvTBhqTcdW9nAdXxznsGmgFo',
            //  yourSiteKey: 'AIzaSyBpj7ZtTQGdQnBzTVDFPn5rjHSLoSwx-GI',
            yourSiteKey:'6LcZeZkpAAAAAHgjSKMTrUdgV_mJO8qxsCyXwkw6',
            googlecaptcha: '',
            captcha: '',
            captchaImage: '',
            captchaToken: ''
        }
    },

    components: {
        CaptchaCode,
        VueRecaptcha,
    },

    mounted: function() {

        // Generate Captcha 
        this.loadCaptcha(); 
    },


    methods: {
         loadCaptcha() {

            this.captcha=''
            this.$http.get(`${CONSTANTS.MIGRATION_API_URL}/generateCaptcha?purpose=shipment_tracking`)
            .then(response => {

                this.captchaImage = response.body.image;
                this.captchaToken = response.body.captchaToken;

            })
            .catch(error => {
                console.log(error);
            });

        },
        onCaptchaVerified(response) {
            this.googlecaptcha ='';
            this.googlecaptcha = response;
            console.log('Captcha verified:', response);
            // You can store the response in your component's data or perform any other actions.
        },
    
        onCaptchaExpired() {
            console.log('Captcha expired');
            // Handle expired reCAPTCHA here if needed.
        },

        reloadCaptcha() {
            // Reset the reCAPTCHA component
            this.$refs.recaptcha.reset();
        },

        // handleClick() {
        //     this.$refs.captcha.refreshCaptcha();
        // },

        // handleChange(code) {
        //     console.log("code:", code);
        // },
    
        // checkcaptcha(){
        //     if(this.text===this.code){
        //         this.capAlert=false;
        //     }
        //     else{
        //         this.capAlert=true;
        //         this.text ='';
        //         this.code ='';
        //         this.handleClick();
        //     }
        // },

        checklength(value){
            console.log("value",value)
            if (value=='') {
                this.items =[];
                this.itemlength =0;
                this.itemsunscces  =''; 
                this.searchviewshipment=false;
                this.showafterview = false;
                this.trackingitems =[];
                this.trackingitemlength = 0;
                this.trackingitemsunscces  = '';
                this.loader = false;
                this.loadert = false;
                this.googlecaptcha ='';
                // this.handleClick();
                this.onCaptchaExpired();
                this.$refs.recaptcha.execute();   
            }
        },

        search(){
            // this.isloader=true;
           
            this.items =[];
                this.itemlength =0;
                this.itemsunscces  =''; 
                this.searchviewshipment=false;
                this.showafterview = false;
                this.trackingitems =[];
                this.trackingitemlength = 0;
                this.trackingitemsunscces  = '';
            if (this.parentawb=='') {
                this.$fire({
                    text: "Please Enter Valid Parent AWB / Invoice No.",
                    type: "warning",
                    timer: 30000,
                });
                this.googlecaptcha ='';
                        this.onCaptchaExpired();
                        this.reloadCaptcha();
                        this.isloader=false;
                return false;
            }
            // this.googlecaptcha !='' 
            // this.text=== this.code


             if(this.captcha!==''){
            const awbArray = this.parentawb
                .split(/[,\s]+/)
                .map(item => item.trim())
                .filter(Boolean);

                this.loader = true;
                let obj = {
                    parentawb: awbArray,
                    captcha: this.captcha,
                    captchaToken: this.captchaToken
                }
                console.log("obj",obj);
                // return false
                this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getParentAwbDetailsPublic`,obj)
                .then(result => {
                    console.log(result)
                    this.loader = false;
                    this.isloader=false;
                    if(result.body.returnmsg === "successful"){
                        this.searchviewshipment=true;
                        this.items  = result.body.returnvalue.parentawb;
                        this.itemlength =  result.body.returnvalue.parentawb[0].length;
                        console.log(this.items)
                         console.log(this.itemlength)
                        this.itemsunscces  =''; 
                        this.captcha=''
                        // this.text ='';
                        // this.code ='';
                        // this.handleClick();
                        this.googlecaptcha ='';
                        this.onCaptchaExpired();
                        this.loadCaptcha();
                    }
                    else {
                        this.items =[];
                        this.itemlength =0;
                        this.itemsunscces  = result.body.returnvalue;
                        // this.text ='';
                        this.captcha=''
                        // this.code ='';
                        // this.handleClick();
                        this.searchviewshipment=false;
                        this.$fire({
                            text: result.body.returnvalue,
                            type: "error",
                            timer: 30000,
                        });
                        this.googlecaptcha ='';
                        this.onCaptchaExpired();
                        this.loadCaptcha();
                    }
                }).catch(ex => {
                    console.log('error', ex)
                })
            }
            
            else{
                this.$fire({
                    text: "Please Enter Valid Captcha",
                    type: "warning",
                    timer: 30000,
                });
                this.isloader=false;
            }
        
        },

        viewtrackingDeatils(value){
            this.isloader=true;
            this.trackingitems =[];
            this.trackingitemlength = 0;
            this.trackingitemsunscces  = '';
            this.showafterview = true;
            this.loadert = true;
            
            let obj = {
                parentawb: value.split(','),
    
            }
            console.log("obj",obj);
            // return false
            // this.$http.post(`${CONSTANTS.MISREPORT_API_URL}
            // /consignmentActivityTrackingPublic`,obj) consignmentActivityTrackingData
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/consignmentActivityTrackingData`,obj) 
             
            .then(result => {
                console.log(result)
                this.loadert = false;
                this.isloader=false;
                if(result.body.returnmsg === "Successful"){
                
                    this.trackingitems  = result.body.returnvalue;
                    this.trackingitemlength =  this.trackingitems.length;
                    console.log(this.trackingitems,this.trackingitemlength)
                }
                else {
                    this.trackingitems =[];
                    this.trackingitemlength = 0;
                    this.trackingitemsunscces  = result.body.returnvalue;
                }
            }).catch(ex => {
                console.log('error', ex)
            })
        },
        downloadPOD() {

            let payload = { parentawb: this.parentawb};

            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadPOD`, payload )
            .then(result => {

                console.log( result.body, "CMS POD DOWNLOAD" );

                // API response
                if (result.body.result == "success") {
                    let data = result.body;
                    let podUrl = '';

                    // Convert poduploadedthrough to lowercase
                    let uploadedThrough = ( data.poduploadedthrough || '').toString().trim().toLowerCase();

                    if (uploadedThrough === 'app') {
                        if ( Array.isArray(data.rider_pod_urls) && data.rider_pod_urls.length > 0) {
                            // Get latest URL from rider_pod_urls
                            podUrl = data.rider_pod_urls[ data.rider_pod_urls.length - 1];
                        }
                    }
                    else if (uploadedThrough === 'cms') {

                        if ( Array.isArray(data.cms_pod_urls) && data.cms_pod_urls.length > 0) {
                            // Get latest URL from cms_pod_urls
                            podUrl = data.cms_pod_urls[ data.cms_pod_urls.length - 1 ];
                        }
                    }

                    if (!podUrl) {
                        alert("POD image not found");
                        return;
                    }

                    window.open( podUrl, "_blank" );

                }
                else {
                    alert(result.body.result);
                }

            })
            .catch(error => {
                console.log(error, "DOWNLOAD POD ERROR" );
                alert("Download Failed");
            });
        },
    },
}
</script>

<style scoped>
#listloader{
    position: fixed; /* Sit on top of the page content */
    width: 100%; /* Full width (cover the whole page) */
    height: 100%; /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.5); /* Black background with opacity */
    z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
  .listloader{
    position: relative;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    width: 30px;
    height: 30px;
    left:50%;
    top:50%;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }
.custom-recaptcha {
    width: 200px;
    height: 40px;
  }
body{
    font-family: Poppins, sans-serif;
}

.card-header {
    background: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.075) 0px 0.125rem 0.25rem !important;
    padding: 3px 20px;
}

.card1{
    border: 1px solid #fff;
    border-radius: 15px;
    box-shadow: rgba(0, 0, 0, 0.075) 0px 0.125rem 0.25rem !important;
}
.card1 .card-body {
    padding: 0px 15px;
}

.tracking {
    border-radius: 14px 0 0px 14px;
    background: rgb(245, 130, 32);
    color: rgb(255, 255, 255);
    text-align: center;
    padding-top: 15px;
    padding-bottom: 20px;
    font-size: 18px;
    font-weight: 600;
}
.tractship {
    color: #fff;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    width: 168px;
}

.parentawb {
    color: #000; 
    font-size: 16px;
    margin-top: 8px;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.iyJSqT {
    box-shadow: rgb(247, 148, 29) 0px 2px 0px;
    border-color: rgb(244, 244, 244);
    background: rgb(244, 244, 244);
    padding: 14px 10px;
    border-radius: 5px;
    margin-right: 10px;
    width: 100%;
}

.form-control-plaintext {
    background-color: initial;
    border: solid transparent;
    border-width: 1px 0;
    border-width: var(--bs-border-width) 0;
    color: #212529;
    color: var(--bs-body-color);
    display: block;
    line-height: 1.5;
    margin-bottom: 0;
    padding: 0.375rem 0;
    width: 100%;
}
.form-control-plaintext:focus {
    border-color: solid transparent; /* Change border color when focused */
        outline: none;
}
@media (min-width: 300px) {
    /* Small devices (landscape phones) and up */
    .tracking {
        font-size: 18px;
        border-radius: 14px 14px 0 0;
    }
    .card1 {
        border: 1px solid #fff;
        box-shadow: rgb(0 0 0 / 10%) 2px 5px 10px !important;
        border-radius: 15px 15px 0 0;
        padding-bottom: 20px;
    }
    .shipfont{
        font-size: 17px;
    }
    /*.iyJSqT{
        margin-left: 7px;
    }*/

    .textcenter{
        text-align: center;
    }

    .paddingout{
        padding: 0 17px;
    }

    .captcha-area {
        width: 200px;
        margin-left: 0px;
    }

    .captcha-area .captcha {
        font-size: 25px;
        letter-spacing: 20px;
        margin-left: 20px;
    }
    .btny{
        margin: 40px 0px 0px 0px;
    }
}

@media (min-width: 576px) {
    /* Small devices (landscape phones) and up */
    .tracking {
        font-size: 18px;
        border-radius: 14px 14px 0 0;
    }
    .card1 {
        border: 1px solid #fff;
        box-shadow: rgb(0 0 0 / 10%) 2px 5px 10px !important;
        border-radius: 15px 15px 0 0;
        padding-bottom: 20px;
    }
    .shipfont{
        font-size: 17px;
    }

    /*.iyJSqT{
        margin-left: 7px;
    }*/

    .textcenter{
        text-align: center;
    }
    .paddingout{
        padding: 0 17px;
    }

    .captcha-area {
        width: 200px;
        margin-left: 50px;
    }

    .captcha-area .captcha {
        font-size: 25px;
        letter-spacing: 20px;
        margin-left: 20px;
    }
}

@media (min-width: 768px) {
    /* Medium devices (tablets) and up */
    .tracking {
        font-size: 16px;
        border-radius: 14px 14px 0 0;
    }
    .card1{
        border: 1px solid #fff;
        border-radius: 15px;
        box-shadow: rgb(0 0 0 / 10%) 2px 2px 8px !important;
    }
    /*.iyJSqT{
        margin-left: -14px;
    }*/

    .paddingout{
        padding: 0 5px 0 0;
    }

    .captcha-area {
        margin-left: 6px;
        width: 130px;
    }

    .captcha-area .captcha{
        font-size: 22px;
        letter-spacing: 12px;
        margin-left: 0;
    }
    .btny{
        margin: 0px 0px 0px 0px;
    }
}

@media (min-width: 992px) {
    /* Large devices (laptops/desktops) and up */
    .tracking {
        font-size: 20px;
        border-radius: 14px 0 0px 14px;
    }
    .card1{
        border: 1px solid #fff;
        border-radius: 15px;
        box-shadow: rgb(0 0 0 / 10%) 2px 2px 8px !important;
        padding-bottom: 0;
    }
    .tractship{
        color: #fff;
        font-size: 15px;
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        width: 168px;
    }
    .iyJSqT {
        box-shadow: rgb(247, 148, 29) 0px 2px 0px;
        border-color: rgb(244, 244, 244);
        background: rgb(244, 244, 244);
        padding: 14px 10px;
        border-radius: 5px;
        margin-right: 10px;
        width: 100%;
        margin-left:0;
    }

    .paddingout {
        padding: 0 7px;
    }

    .captcha-area .captcha {
        font-size: 22px;
        letter-spacing: 14px;
        margin-left : 0;
    }
    
    .captcha-area {
        margin-left: 0px;
        width:127px;
    }
}

@media (min-width:1254px) {
    .tracking {
        font-size: 20px;
        border-radius: 14px 0 0px 14px;
    }
    .card1{
        border: 1px solid #fff;
        border-radius: 15px;
        box-shadow: rgb(0 0 0 / 10%) 2px 2px 8px !important;
        padding-bottom: 0;
    }
    .tractship{
        color: #fff;
        font-size: 15px;
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
        width: 168px;
    }
    .iyJSqT {
        box-shadow: rgb(247, 148, 29) 0px 2px 0px;
        border-color: rgb(244, 244, 244);
        background: rgb(244, 244, 244);
        padding: 14px 10px;
        border-radius: 5px;
        margin-right: 10px;
        width: 100%;
        margin-left:0;
    }

    .paddingout {
        padding: 0 7px;
    }

    .captcha-area .captcha {
        font-size: 24px;
        letter-spacing: 15px;
        margin-left : 0;
    }
    
    .captcha-area {
        margin-left: 40px;
        width: 180px;
    }
    .btny[data-v-f78ee448] {
        margin: 0px 0px 0px 0px;
    }
}
.btny, .btny:active, .btny:focus, .btny:hover {
    background: rgb(245, 130, 32);
    color: #fff;
    border: 2px solid #f37c0e;
    padding: 18px;
    box-shadow: none;
    outline: none;
    transition: background 0.3s, color 0.3s, transform 0.3s;
}

.btny:hover {
    background: #f37c0e;
    color: #fff;
    transform: scale(1.1);
}

.btny:active {
    transform: scale(0.9);
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    word-wrap: break-word;
}

th {
    background-color: #f2f2f2;
}

@media screen and (max-width: 600px) {
    table {
        border: none;
    }

    thead {
        display: none;
    }

    tbody, tr, td {
        display: block;
        width: 100%;
        box-sizing: border-box;
    }

    td:before {
        content: attr(data-label);
        font-weight: bold;
        display: block;
        margin-bottom: 5px;
    }

    .styled-table {
        font-size: 0.8em;
    }

    .styled-table th,
    .styled-table td {
        padding: 0.3em;
        display: block;
        text-align: center;
    }

    .styled-table td:before {
        content: attr(data-label);
        float: left;
        font-weight: bold;
    }
}
.shipmentview {
    background: #eeeeee5e;
    word-break: break-all;
}

table th, table td{
    border: 1px solid #00000040;
}

.tableheadershow {
    background: #f58733fa;
    padding: 12px 0px;
    border-radius: 10px;
    color: #fff;
    font-weight: 600;
    font-family: monospace;
    font-size: 15px;
     white-space: nowrap;
}

.contentshow {
    opacity: 0; /* Start with opacity 0 */
    transition: opacity 1s ease-in-out; /* Apply a smooth transition on opacity */
  }

  .contentshow.active {
    opacity: 1; /* When the 'active' class is added, opacity becomes 1, revealing the content */
  }

  .spinnerdiv {
    position: absolute;
    right: 50%;
    margin: 20px 0px;
  }

  .broder{
    border-bottom: 2px solid;
  }

.styled-table {
    width: 100%;
    border-collapse: collapse;
    margin: 1em 0;
    font-size: 1em;
    text-align: left;
}

.styled-table th,
.styled-table td {
    padding: 0.5em;
    border: 1px solid #ddd;
}


.rc-anchor-normal .rc-anchor-checkbox-label {
    width: 90px !important;
}

.rc-anchor-normal .rc-anchor-content {
    height: 74px !important;
    width: 142px !important;
}


.rc-anchor-logo-portrait {
    margin: 10px 0 0 5px !important;
    width: 58px !important;
}

.rc-anchor-normal .rc-anchor-pt {
    margin: 2px 91px 0 0 !important;
    padding-right: 2px !important;
    position: absolute !important;
    right: 0 !important;
    text-align: right !important;
    width: 276px !important;
}

.rc-anchor-light {
    background: #f9f9f9 !important;
    color: #000 !important;
    width: 225px !important;
}
</style>
<!-- #00c0ef!important 
    rgb(245, 130, 32)
 background: #00c0ef;
    padding: 50px;
 width: 19%;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    display: flex;
    flex-direction: column;-->